import { useTranslation } from "react-i18next";
import { SegmentedTabs } from "@/components/kit";
import { useTheme } from "@/hooks/useTheme";
import insonUchunIcon from "@/assets/insonUchun.svg";
import bazaarLightIcon from "@/assets/logo/bazaarLightIcon.png";
import bazaarDarkIcon from "@/assets/logo/bazaarDarkIcon.png";

export type HomeSection = "children" | "bazaar";

interface HomeSegmentProps {
  value: HomeSection;
  onChange: (next: HomeSection) => void;
}

/** Segment ikonasi — barcha rasm turlari uchun bir xil o'lcham/joylashuv. */
export function SegIcon({ src, size = 18 }: { src: string; size?: number }) {
  return (
    <img
      src={src}
      alt=""
      aria-hidden
      className="shrink-0 object-contain"
      style={{ width: size, height: size }}
    />
  );
}

/**
 * Home tab segmented toggle: "Bemorlar" ↔ "Maktab bozori" (Figma §6.1/§6.6).
 * Ikonalar: Bemorlar — Inson Uchun brend belgisi; Maktab bozori — temaga mos
 * (light/dark) alohida ikonka (`resolvedTheme` orqali tanlanadi).
 */
export function HomeSegment({ value, onChange }: HomeSegmentProps) {
  const { t } = useTranslation();
  const { resolvedTheme } = useTheme();
  const bazaarIcon = resolvedTheme === "dark" ? bazaarDarkIcon : bazaarLightIcon;

  return (
    <div className="mb-4">
      <SegmentedTabs<HomeSection>
        value={value}
        onChange={onChange}
        items={[
          { id: "children", label: t("segChildren"), icon: <SegIcon src={insonUchunIcon} /> },
          { id: "bazaar", label: t("segBazaar"), icon: <SegIcon src={bazaarIcon} /> },
        ]}
      />
    </div>
  );
}
